<template>
    <section>
        <div class="col-sm-12 mt-4">
          <small class="pl-2">{{ $t('reservation.media.title') }}</small>
        </div>
        <core-file-upload
            class="col-sm-12 mt-2"
            :serviceId="reservationLineId"
            @uploaded="storeServiceMedia"
        />
        <div
            class="col-sm-12"
            v-for="(media, index) in reservationMedia"
            :key="index"
        >
          <reservation-details-media-item
            class="mb-2"
            :item="media"
            @deleted="getReservationLineMedia"
          />
        </div>
    </section>
</template>
<script>

import ReservationLineMedia from '@/services/hatsApi/ReservationLineMedia'

export default {
  props: {
    reservationLineId: {
      type: String | Number,
      required: true
    }
  },
  data () {
    return {
      reservationMedia: []
    }
  },
  mounted () {
    this.getReservationLineMedia()
  },
  methods: {
    async storeServiceMedia (media) {
      let params = {
        reservationLineId: this.reservationLineId,
        mediaId: media.id,
        name: media.name,
        languageId: 1
      }

      const storeMediaResponse = await ReservationLineMedia.attachMediaToReservationLine(params)
      if (storeMediaResponse.data.success === true) {
        this.getReservationLineMedia()
      } else {
        console.log('Error', storeMediaResponse)
      }
    },
    async getReservationLineMedia () {
      try {
        let filters = [
          {
            property: 'reservationLineId',
            value: this.reservationLineId
          }
        ]
        const reservationMediaResponse = await ReservationLineMedia.getCollection(filters)
        if (reservationMediaResponse.data.success) {
          this.reservationMedia = reservationMediaResponse.data.data
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservation/details/MediaBox.vue